"use client";

export function HomeStyles() {
  return (
    <style jsx global>{`
      .home-shell {
        --home-bg: url("/images/own-images/background.jpg");
        --home-ink: #442d1f;
        --home-muted: #6d5848;
        --home-accent: #9f7851;
        --home-soft: #f3e6d5;
        --home-dark: #4a3023;
        min-height: 100svh;
        background: var(--home-bg);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        background-attachment: fixed;
      }

      .font-khmer {
        font-family: var(--font-hanuman), var(--font-khmer-google), serif;
      }

      .home-panel {
        border: 1px solid rgba(125, 89, 57, 0.12);
        background: rgba(255, 252, 247, 0.72);
        border-radius: 2rem;
        box-shadow: 0 20px 60px rgba(78, 53, 30, 0.08);
        backdrop-filter: blur(10px);
      }

      .hero-section {
        background: transparent;
      }

      .hero-section__wash {
        background: transparent;
        opacity: 0;
        pointer-events: none;
      }

      .hero-card::before {
        content: "";
        position: absolute;
        inset: -1.25rem;
        border-radius: 2.6rem;
        background:
          radial-gradient(circle at top, rgba(255, 248, 231, 0.82), transparent 38%),
          linear-gradient(180deg, rgba(255, 255, 255, 0.4), rgba(214, 206, 193, 0.12));
        filter: blur(18px);
        opacity: 0.88;
        z-index: 0;
        pointer-events: none;
      }

      .hero-card--reveal {
        opacity: 0;
        transform: translateY(34px) scale(0.985);
        transition:
          opacity 800ms ease,
          transform 800ms ease;
      }

      .hero-card--visible {
        opacity: 1;
        transform: translateY(0) scale(1);
      }

      .hero-fade-block {
        opacity: 0;
        transform: translateY(24px);
        transition:
          opacity 1200ms ease,
          transform 1200ms ease;
      }

      .hero-fade-block--visible {
        opacity: 1;
        transform: translateY(0);
      }

      .hero-card__shell::before {
        content: "";
        position: absolute;
        inset: 0.6rem;
        border-radius: 1.8rem;
        border: 1px solid rgba(173, 146, 107, 0.22);
        pointer-events: none;
        z-index: 1;
      }

      .hero-card__floral {
        background:
          radial-gradient(circle at top left, rgba(255, 247, 233, 0.25), transparent 22%),
          radial-gradient(circle at top right, rgba(255, 239, 213, 0.18), transparent 20%),
          linear-gradient(180deg, rgba(255, 248, 231, 0.08), transparent 28%);
        pointer-events: none;
      }

      .hero-card__title-wrap {
        box-shadow:
          inset 0 1px 0 rgba(255, 249, 236, 0.4),
          0 14px 34px rgba(34, 20, 12, 0.14);
      }

      .hero-card__kh-title {
        color: #ffffff;
        text-shadow:
          0 1px 0 rgba(255, 248, 231, 0.92),
          0 3px 10px rgba(0, 0, 0, 0.16);
        -webkit-text-stroke: 0.75px rgba(206, 161, 86, 0.88);
      }

      .hero-card__eng {
        color: #ffffff;
        letter-spacing: 0.08em;
        text-shadow:
          0 1px 0 rgba(255, 248, 231, 0.86),
          0 4px 10px rgba(0, 0, 0, 0.14);
        -webkit-text-stroke: 0.5px rgba(206, 161, 86, 0.8);
      }

      .hero-card__name {
        color: #fff8f0;
        text-shadow:
          0 1px 0 rgba(255, 232, 189, 0.34),
          0 8px 22px rgba(0, 0, 0, 0.24);
      }

      .hero-card__heart {
        display: inline-block;
        filter: drop-shadow(0 4px 12px rgba(74, 43, 18, 0.28));
        transform-origin: center;
        animation: heroHeartBeat 2.2s ease-in-out infinite;
      }

      .hero-card__save {
        font-feature-settings: "c2sc" 1, "smcp" 1;
      }

      .hero-invite-title {
        color: #c28d38;
        text-shadow:
          0 1px 0 rgba(255, 245, 220, 0.9),
          0 2px 0 rgba(230, 190, 116, 0.32);
        -webkit-text-stroke: 0.35px rgba(182, 130, 46, 0.55);
      }

      .hero-invite-body {
        color: #5d7388;
        font-weight: 500;
        letter-spacing: 0.01em;
        text-shadow: 0 1px 0 rgba(255, 255, 255, 0.42);
      }

      .hero-waiting-badge {
        position: relative;
      }

      .hero-waiting-badge__text {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 1.2rem;
        color: #c28d38;
        text-align: center;
        text-shadow: 0 1px 0 rgba(255, 247, 230, 0.72);
      }

      .hero-timer-card {
        background:
          linear-gradient(180deg, rgba(255, 245, 220, 0.26), rgba(255, 245, 220, 0) 36%),
          linear-gradient(135deg, #d2b07a 0%, #bb955a 52%, #9f7540 100%);
        box-shadow:
          inset 0 1px 0 rgba(255, 248, 231, 0.68),
          inset 0 -8px 16px rgba(122, 85, 40, 0.16),
          0 14px 26px rgba(116, 88, 49, 0.16);
      }

      .hero-timer-number {
        display: inline-block;
        line-height: 1;
        text-shadow:
          0 1px 0 rgba(255, 255, 255, 0.88),
          0 2px 0 rgba(236, 214, 175, 0.62),
          0 4px 10px rgba(110, 72, 29, 0.22),
          0 10px 18px rgba(0, 0, 0, 0.16);
        transform: translateY(-1px);
      }

      .snow-flake {
        position: absolute;
        top: -8%;
        border-radius: 9999px;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0 0 8px rgba(255, 255, 255, 0.18);
        animation-name: subtleSnowFall;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
      }

      @keyframes subtleSnowFall {
        0% {
          transform: translate3d(0, -10vh, 0);
        }
        25% {
          transform: translate3d(8px, 22vh, 0);
        }
        50% {
          transform: translate3d(-6px, 50vh, 0);
        }
        75% {
          transform: translate3d(10px, 78vh, 0);
        }
        100% {
          transform: translate3d(-4px, 112vh, 0);
        }
      }

      .home-eyebrow {
        font-size: 0.72rem;
        line-height: 1;
        text-transform: uppercase;
        letter-spacing: 0.34em;
        color: var(--home-accent);
      }

      .home-button,
      .home-button-secondary {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-height: 3.25rem;
        border-radius: 9999px;
        padding: 0.9rem 1.6rem;
        font-size: 0.8rem;
        font-weight: 600;
        letter-spacing: 0.18em;
        text-transform: uppercase;
        transition: transform 160ms ease, filter 160ms ease, box-shadow 160ms ease;
      }

      .home-button {
        background: linear-gradient(135deg, #c69c66, #8d6039);
        color: #fff5e5;
        box-shadow: 0 16px 36px rgba(106, 71, 38, 0.28);
      }

      .cover-open-button {
        position: relative;
        overflow: hidden;
        min-height: 3.75rem;
        padding: 1rem 2.2rem;
        border: 1px solid rgba(255, 231, 184, 0.38);
        background:
          linear-gradient(180deg, rgba(255, 245, 224, 0.3), rgba(255, 245, 224, 0) 38%),
          linear-gradient(135deg, #f1cd8a 0%, #c08a49 48%, #8d5a2c 100%);
        color: #fff8ee;
        font-size: 0.95rem;
        letter-spacing: 0.2em;
        text-shadow:
          0 1px 0 rgba(133, 78, 25, 0.72),
          0 3px 12px rgba(48, 24, 10, 0.28);
        box-shadow:
          0 22px 34px rgba(58, 31, 12, 0.3),
          0 10px 0 rgba(122, 75, 37, 0.9),
          inset 0 1px 0 rgba(255, 249, 235, 0.7),
          inset 0 -10px 18px rgba(102, 58, 24, 0.26);
        transition:
          transform 180ms ease,
          box-shadow 180ms ease,
          filter 180ms ease;
        animation: coverButtonFloat 2.8s ease-in-out infinite;
      }

      .cover-open-button::before {
        content: "";
        position: absolute;
        inset: 0.2rem;
        border-radius: 9999px;
        border: 1px solid rgba(255, 244, 218, 0.3);
        pointer-events: none;
      }

      .cover-open-button::after {
        content: "";
        position: absolute;
        top: -20%;
        left: -30%;
        width: 50%;
        height: 140%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.42), transparent);
        transform: rotate(18deg);
        opacity: 0.9;
        animation: coverButtonShine 3.2s ease-in-out infinite;
        pointer-events: none;
      }

      .cover-open-button-label {
        position: relative;
        z-index: 1;
      }

      .cover-open-button:hover {
        transform: translateY(-4px);
        filter: brightness(1.05);
        box-shadow:
          0 28px 42px rgba(58, 31, 12, 0.34),
          0 12px 0 rgba(122, 75, 37, 0.92),
          inset 0 1px 0 rgba(255, 249, 235, 0.76),
          inset 0 -10px 18px rgba(102, 58, 24, 0.22);
      }

      .cover-open-button:active {
        transform: translateY(6px);
        box-shadow:
          0 14px 22px rgba(58, 31, 12, 0.22),
          0 5px 0 rgba(122, 75, 37, 0.9),
          inset 0 1px 0 rgba(255, 249, 235, 0.56),
          inset 0 -8px 14px rgba(102, 58, 24, 0.24);
      }

      .home-button-secondary {
        border: 1px solid rgba(255, 242, 218, 0.26);
        background: rgba(255, 255, 255, 0.08);
        color: #f8ead2;
        backdrop-filter: blur(8px);
      }

      .home-button:hover,
      .home-button-secondary:hover {
        transform: translateY(-1px);
        filter: brightness(1.04);
      }

      .home-music-button {
        position: fixed;
        right: 1rem;
        bottom: 1rem;
        z-index: 40;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 3rem;
        height: 3rem;
        border-radius: 9999px;
        border: 1px solid rgba(216, 188, 134, 0.34);
        background: linear-gradient(180deg, #8f6b3f 0%, #6f4f2b 100%);
        color: #fff5df;
        box-shadow:
          0 14px 28px rgba(54, 33, 13, 0.26),
          inset 0 1px 0 rgba(255, 235, 197, 0.24),
          inset 0 -8px 14px rgba(44, 24, 8, 0.22);
        backdrop-filter: blur(10px);
        transition:
          transform 180ms ease,
          box-shadow 180ms ease,
          background 180ms ease,
          color 180ms ease;
        animation: homeMusicFloat 3.2s ease-in-out infinite;
      }

      .home-music-button[data-playing="true"] {
        box-shadow:
          0 18px 32px rgba(46, 27, 10, 0.32),
          inset 0 1px 0 rgba(255, 237, 206, 0.28),
          inset 0 -10px 16px rgba(33, 17, 5, 0.28);
        animation: homeMusicPulse 1.8s ease-in-out infinite;
      }

      .home-music-button svg {
        transition: transform 180ms ease, opacity 180ms ease;
      }

      .home-music-button[data-playing="true"] svg {
        animation: homeMusicIconBeat 1.2s ease-in-out infinite;
      }

      .home-music-button:hover {
        transform: translateY(-2px) scale(1.03);
      }

      .home-music-button:active {
        transform: translateY(0) scale(0.98);
      }

      .home-music-button:focus-visible {
        outline: 2px solid rgba(197, 168, 115, 0.9);
        outline-offset: 4px;
      }

      @keyframes homeMusicFloat {
        0%,
        100% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-3px);
        }
      }

      @keyframes homeMusicPulse {
        0%,
        100% {
          transform: translateY(0) scale(1);
          box-shadow:
            0 18px 32px rgba(46, 27, 10, 0.32),
            inset 0 1px 0 rgba(255, 237, 206, 0.28),
            inset 0 -10px 16px rgba(33, 17, 5, 0.28);
        }
        50% {
          transform: translateY(-2px) scale(1.06);
          box-shadow:
            0 22px 40px rgba(46, 27, 10, 0.36),
            inset 0 1px 0 rgba(255, 237, 206, 0.32),
            inset 0 -10px 16px rgba(33, 17, 5, 0.3);
        }
      }

      @keyframes homeMusicIconBeat {
        0%,
        100% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.12);
        }
      }

      .cover-title-3d {
        text-shadow:
          0 1px 0 rgba(255, 255, 255, 0.92),
          0 3px 10px rgba(97, 60, 21, 0.22),
          0 10px 24px rgba(0, 0, 0, 0.26);
        -webkit-text-stroke: 1px rgba(184, 134, 52, 0.98);
      }

      .cover-name-3d {
        text-shadow:
          0 1px 0 rgba(255, 255, 255, 0.92),
          0 3px 10px rgba(97, 60, 21, 0.2),
          0 8px 18px rgba(0, 0, 0, 0.24);
        -webkit-text-stroke: 0.9px rgba(186, 138, 58, 0.96);
      }

      .cover-text-outline {
        text-shadow:
          0 1px 0 rgba(255, 255, 255, 0.92),
          0 3px 10px rgba(97, 60, 21, 0.2),
          0 8px 18px rgba(0, 0, 0, 0.24);
        -webkit-text-stroke: 0.95px rgba(188, 140, 60, 0.96);
      }

      .cover-stage {
        box-shadow:
          0 36px 120px rgba(19, 10, 5, 0.48),
          0 12px 28px rgba(255, 232, 191, 0.08),
          inset 0 1px 0 rgba(255, 245, 226, 0.22),
          inset 0 -14px 28px rgba(0, 0, 0, 0.2);
      }

      .cover-stage::before {
        content: "";
        position: absolute;
        inset: 0.7rem;
        border-radius: 1.45rem;
        border: 1px solid rgba(255, 236, 204, 0.34);
        box-shadow:
          inset 0 1px 0 rgba(255, 255, 255, 0.24),
          0 0 0 1px rgba(125, 75, 35, 0.18),
          0 18px 40px rgba(18, 9, 4, 0.24);
        pointer-events: none;
        z-index: 1;
      }

      .cover-stage::after {
        content: "";
        position: absolute;
        inset: 1.15rem;
        border-radius: 1.1rem;
        background: linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.12),
          transparent 34%,
          transparent 64%,
          rgba(0, 0, 0, 0.12)
        );
        pointer-events: none;
        z-index: 1;
      }

      @keyframes coverButtonFloat {
        0%,
        100% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-2px);
        }
      }

      @keyframes coverButtonShine {
        0% {
          transform: translateX(-180%) rotate(18deg);
          opacity: 0;
        }
        18% {
          opacity: 0.95;
        }
        45%,
        100% {
          transform: translateX(280%) rotate(18deg);
          opacity: 0;
        }
      }

      @keyframes heroHeartBeat {
        0%,
        100% {
          transform: translateY(0) scale(1);
          filter: drop-shadow(0 0 0 rgba(255, 226, 167, 0)) drop-shadow(0 4px 12px rgba(74, 43, 18, 0.28));
        }
        20% {
          transform: translateY(-1px) scale(1.08);
          filter: drop-shadow(0 0 12px rgba(255, 214, 136, 0.28)) drop-shadow(0 6px 14px rgba(74, 43, 18, 0.24));
        }
        35% {
          transform: translateY(-2px) scale(1.18);
          filter: drop-shadow(0 0 16px rgba(255, 214, 136, 0.34)) drop-shadow(0 8px 18px rgba(74, 43, 18, 0.22));
        }
        50% {
          transform: translateY(-1px) scale(1.08);
          filter: drop-shadow(0 0 12px rgba(255, 214, 136, 0.26)) drop-shadow(0 6px 14px rgba(74, 43, 18, 0.22));
        }
        70% {
          transform: translateY(0) scale(1);
          filter: drop-shadow(0 0 4px rgba(255, 214, 136, 0.12)) drop-shadow(0 4px 12px rgba(74, 43, 18, 0.26));
        }
      }

      @media (min-width: 768px) {
        .home-music-button {
          right: 1.5rem;
          bottom: 1.5rem;
        }
      }
    `}</style>
  );
}
